import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper, { cleanCollisions, continuousExtentParts } from '../chart_helpers/AxisHelper'
import SizeHelper from '../chart_helpers/SizeHelper'
import { categoricalExtent, continuousExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import { dentedRect, tweenDentedRect } from '../utils/pathUtils'
import { scaleBand as d3_scaleBand } from 'd3-scale'
import TrendLinesHelper from '../chart_helpers/TrendLinesHelper'
import { interpolate as d3_interpolate, interpolateRgb as d3_interpolateRgb } from 'd3-interpolate'
import * as COLORS from '../utils/colorUtils'
import { select as d3_select } from 'd3-selection'
import { isDarkMode } from '../utils/configUtils'
import { ACCESSIBILITY_OPTIONS_KEYS } from '../utils/accessibilityUtils'

const MAX_BAR_WIDTH = 40
const MANUAL_BAR_WIDTH_STEPS = 10
export default class BarChartChart extends BaseChart {
  constructor(...args) {
    super(...args)
    this.zeroBased = true
  }
  static defaultConfig = {
    /**
     * {-EN-} Orientation of the bars. When setting `horizontal: true` the x and y axes will be swapped.
     * {-ES-} Orientación de las barras. Al configurar `horizontal: true`, los ejes x e y se intercambiarán.
     */
    horizontal: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    mode: {
      type: String,
      default: 'single',
      options: ['single', 'grouped', 'stacked', 'progress'],
    },
    dataSorting: {
      type: [String],
      default: 'none',
      options: ['none', 'asc', 'desc'],
      exposed: true,
    },
    /**
     * {-EN-} Show the value on top of each bar.
     * {-ES-} Muestra el valor encima de cada barra.
     */
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    datumValuesPosition: {
      type: String,
      default: 'top',
      options: ['top', 'center', 'bottom', 'insideBeginning', 'insideEnd'],
      exposed: true,
    },
    /**
     * {-EN-} Custom bar width (from 1 to 5)
     * {-ES-} Ancho de barra personalizado (de 1 a 5)
     */
    manualBarWidth: {
      type: [Number, String, null],
      options: Array.from(Array(MANUAL_BAR_WIDTH_STEPS))
        .map((_, i) => [i + 1, (i + 1).toString()])
        .flat(),
      default: null,
      exposed: true,
    },
    /**
     * {-EN-} Minimum height of each bar (in pixels).
     * {-ES-} Altura mínima de cada barra (en píxeles).
     */
    minBarHeight: {
      type: [Number],
      default: 0,
      exposed: true,
    },
    placeholderColor: {
      type: [String, null],
      default: null,
      exposed: false,
    },
    AxisHelper: {
      zoom: {
        nonEditable: true,
      },
      scroll: {
        default: false,
        exposed: true,
      },
      showScrollbar: {
        default: true,
        exposed: true,
      },
      x: {
        scale: {
          value: 'band',
          exposed: false,
        },
        getExtent: function (data) {
          if (this.config.mode === 'stacked') return categoricalExtent(data)
          //return data[0].value.map((d)=>d.id)
          else if (this.config.mode === 'grouped') return categoricalExtent(data)
          //return data[0].value.map((d)=>d.id)
          else return categoricalExtent(data) //return data.map((d)=>d.id)
        },
      },
      y: {
        side: 'right',
        getExtent: function (data) {
          let extent, extentParts
          if (this.config.mode === 'stacked') {
            extentParts = continuousExtentParts(data, d => [d.y0, d.y1])
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts)
          } else if (this.config.mode === 'grouped') {
            extentParts = continuousExtentParts(data)
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts) //d3.extent(data.reduce((res,d)=>res.concat(d3.extent(d.value,(dd)=>dd.value)),[]))
          } else if (this.config.mode === 'progress') {
            return [0, 100]
          } else {
            extentParts = data.map(d => ({ value: [d.value, d.value] })) //ESTABA MAL ESTOª!!!!! no?
            // console.log("extent parts",extentParts)
            extent = continuousExtent(data) //d3.extent(data,(d)=>d.value)
          }

          //Protect label!
          // let originalExtent = extent

          // extent = padLinear(extent,0.2)

          // NOT GOOD, porque se hace el padlinear luego, en el _setDomain
          // if(originalExtent[0]>=0) extent[0]=0
          // console.log("bar extent bef",extent)
          if (this.config.AxisHelper.y.showTickValues && this.config.AxisHelper.y.unit) {
            extent = cleanCollisions(this.axes.y, extent, extentParts)
          }
          // console.log("bar extent aft",extent)
          return extent
        },
      },
    },
    TooltipBehavior: {
      getItemOffset: function ($el) {
        let original = $el.getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top, //- 5,
        }
      },
    },
    TrendLinesHelper: {
      /*
      linesDict: {
        value: {
          line_1: {
            serie: 'all',
            type: 'min',
            label: 'Trend line 1',
            color: '#CC0000',
            polynomialOrder: '3',
          },
        },
      },
      */
      /*
      getItemOffset: function (d) {
        const getPositions = (x, y) => {
          if (this.config.horizontal) return { x: y, y: x }
          return { x, y }
        }

        let getOffset = v => {
          if (this.axes.y.func.scale().domain()[0] === 0)
            return Math.min(v, this.axes.y.func.scale()(offsetValue))
          else return this.axes.y.func.scale()(offsetValue)
        }
        let offsetValue
        if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
          offsetValue = 0
        else offsetValue = this.axes.y.func.scale().domain()[0]

        let barPercent = 0.7
        let barWidth = Math.min(MAX_BAR_WIDTH, this.axes.x.scale.bandwidth() * barPercent)
        let barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2
        let subBarWidth

        if (this.config.mode === 'stacked') {
          let stackPadding = 2
          let barPos = this.axes.y.func.scale()(this.config.horizontal ? d.y0 : d.y1)
          return getPositions(
            this.axes.x.func.scale()(d.id) + barMargin,
            this.axes.y.func.scale()(d.value)
          )
        } else if (this.config.mode === 'grouped') {
          barWidth = this.axes.x.scale.bandwidth() * barPercent
          barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2
          let subScale = d3_scaleBand()
            .domain(this.data.map(d => d.id))
            .range([barMargin, barMargin + barWidth]) //.range([w/2-w/6,w/2+w/3-w/6])
          let subBarPercent = 0.7
          // let subBarWidth = subScale.bandwidth()*subBarPercent
          // let subBarMargin = subScale.bandwidth()*(1-subBarPercent)/2
          subBarWidth = Math.min(MAX_BAR_WIDTH, subScale.bandwidth() * subBarPercent)
          let subBarMargin = (subScale.bandwidth() - subBarWidth) / 2
          let barPos = getOffset(this.axes.y.func.scale()(d.safeValue))
          return getPositions(
            this.axes.x.func.scale()(d.id) + barWidth / 2,
            this.axes.y.func.scale()(d.value) //barPos
          )
        } else {
          return getPositions(
            this.axes.x.func.scale()(d.id) + barMargin + barWidth / 2,
            this.axes.y.func.scale()(d.value)
          )
        }
      },
      */
      getCategoriesData: function () {
        if (this.config.mode === 'grouped') {
          return this.data
            .reduce((accumulator, current) => {
              current.value.forEach(value => {
                accumulator.push(value)
              })
              return accumulator
            }, [])
            .flat()
        }
        return this.data.map(item => ({ parentId: item.id, ...item }))
      },
    },
    highlightMaxValue: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    highlightMinValue: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    hasColorPatterns: {
      type: Boolean,
      default: true,
      exposed: false,
    },
  }
  static helpers = [
    RootHelper,
    ItemsHelper,
    SelectableHelper,
    SizeHelper,
    AxisHelper,
    TrendLinesHelper,
  ]
  checkConsistency() {
    return true
  }
  draw() {
    let self = this
    let longDir, getTranslate, getOffset, getShort //,shortDir

    let barWidth, subBarWidth

    function fillTween(d) {
      const fill = self.fill(d)
      if (fill?.includes('url'))
        return function (t) {
          return fill
        }
      else {
        const currentFill = d3_select(this).attr('fill')
        var i = d3_interpolateRgb(currentFill, fill)
        return function (t) {
          return i(t)
        }
      }
    }

    if (this.config.horizontal) {
      longDir = 'height'
      // shortDir = 'width'
      getTranslate = (long, short) => {
        return `translate(${short},${long})`
      }

      let offsetValue
      if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
        offsetValue = 0
      else offsetValue = this.axes.y.func.scale().domain()[0]

      getOffset = v => Math.min(v, this.axes.y.func.scale()(offsetValue))
      /* Da problemas con los valores negativos
      getOffset = v => {
        if (this.axes.y.func.scale().domain()[0] === 0)
          return Math.min(v, this.axes.y.func.scale()(offsetValue))
        else return this.axes.y.func.scale()(offsetValue)
      }
      */
      // getShort = v => Math.abs(this.axes.y.func.scale()(offsetValue) - v)
      getShort = v => {
        let val = this.axes.y.func.scale()(offsetValue) - v
        return Math.abs(val)
      }
    } else {
      longDir = 'width'
      // shortDir = 'height'
      getTranslate = (long, short) => {
        return `translate(${long},${short})`
      }

      let offsetValue
      if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
        offsetValue = 0
      else offsetValue = this.axes.y.func.scale().domain()[0]

      getOffset = v => Math.min(v, this.axes.y.func.scale()(offsetValue))
      // getShort = v => Math.abs(this.axes.y.func.scale()(offsetValue) - v)
      getShort = v => {
        let val = this.axes.y.func.scale()(offsetValue) - v
        return Math.abs(val)
      }
    }

    let barPercent = 0.7
    barWidth = Math.min(MAX_BAR_WIDTH, this.axes.x.scale.bandwidth() * barPercent)

    this.config.manualBarWidth !== null &&
      (barWidth = (this.config.manualBarWidth / (MANUAL_BAR_WIDTH_STEPS / 2)) * barWidth)
    //(barWidth = ((barWidth * 2) / 10) * this.config.manualBarWidth * 2)
    let barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2
    let drawItem
    if (this.config.mode === 'stacked') {
      let stackPadding = 2
      drawItem = (sel, status) => {
        sel.attr('transform', d => {
          let barPos
          if (status === 'enter' || status === 'exit') barPos = this.axes.y.func.scale()(0)
          else {
            //Condition in order to prevent overlapping when setting manual domain
            if (
              this.config.horizontal &&
              !d.isFirstLayer &&
              d.y0 < this.axes.y.func.scale().domain()[0]
            ) {
              barPos = 0
            } else {
              barPos = this.axes.y.func.scale()(this.config.horizontal ? d.y0 : d.y1)
            }
          }
          return getTranslate(
            this.axes.x.func.scale()(d.id) + barMargin,
            barPos +
              (this.config.horizontal
                ? d.isFirstLayer && this.axes.y.func.scale().domain()[0] > 0
                  ? Math.abs(this.axes.y.func.scale()(0))
                  : 0
                : stackPadding / 2)
          )
        })

        sel.select('.main-path').attrTween &&
          sel.select('.main-path').attrTween('d', function (d) {
            let barLength
            if (status === 'enter' || status === 'exit') barLength = 0
            else {
              let [y0, y1] = [d.y0, d.y1]
              //Condition block in order to prevent overlapping when setting manual domain
              //Check if is negative domain
              if (self.axes.y.func.scale().domain()[0] < 0)
                barLength =
                  getShort(self.axes.y.func.scale()(d.safeValue)) -
                  (d.isFirstLayer ? stackPadding : stackPadding)
              //Check if domain is higher than the data and if is not first layer
              else if (!d.isFirstLayer && y0 < self.axes.y.func.scale().domain()[0]) {
                barLength = getShort(self.axes.y.func.scale()(y1)) - stackPadding
              } else {
                self.config.horizontal
                  ? (barLength =
                      getShort(
                        self.axes.y.func.scale()(y1) -
                          self.axes.y.func.scale()(y0) -
                          (d.isFirstLayer ? Math.abs(self.axes.y.func.scale()(0)) : 0)
                      ) - stackPadding)
                  : (barLength =
                      getShort(
                        self.axes.y.func.scale()(y1) -
                          self.axes.y.func.scale()(y0) +
                          (!d.isFirstLayer
                            ? self.axes.y.func.scale().range()[0]
                            : self.axes.y.func.scale()(0))
                      ) - stackPadding)
              }
            }
            barLength = Math.max(barLength, 0) //y le faltaba esto para cuando el "safeValue" da 0!!!

            return tweenDentedRect.call(this, d, {
              barLength,
              barWidth,
              longDir,
              scale: self.axes.y.func.scale(),
            })
          }) &&
          sel.select('.main-path').attrTween('fill', function (d) {
            return fillTween.bind(this)({ ...d, id: d.parentId })
          })
      }
    } else if (this.config.mode === 'grouped') {
      barWidth = this.axes.x.scale.bandwidth() * barPercent
      this.config.manualBarWidth !== null &&
        (barWidth = (this.config.manualBarWidth / (MANUAL_BAR_WIDTH_STEPS / 2)) * barWidth)
      barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2
      const barIds = this.data.map(d => d.id)
      let subScale = d3_scaleBand()
        .domain(barIds)
        .range([barMargin, barMargin + barWidth]) //.range([w/2-w/6,w/2+w/3-w/6])
      let subBarPercent = 0.7
      // let subBarWidth = subScale.bandwidth()*subBarPercent
      // let subBarMargin = subScale.bandwidth()*(1-subBarPercent)/2
      subBarWidth = Math.min(MAX_BAR_WIDTH, subScale.bandwidth() * subBarPercent)
      //Specific subBarWidth if there is only one group in order to avoid overlapping with multiple groups
      this.config.manualBarWidth !== null &&
        barIds.length === 1 &&
        (subBarWidth = (this.config.manualBarWidth / (MANUAL_BAR_WIDTH_STEPS / 2)) * subBarWidth)
      let subBarMargin = (subScale.bandwidth() - subBarWidth) / 2
      drawItem = (sel, status) => {
        sel.attr('transform', d => {
          let barPos
          if (status === 'enter' || status === 'exit')
            barPos = getOffset(this.axes.y.func.scale()(0))
          else barPos = getOffset(this.axes.y.func.scale()(d.safeValue))
          return getTranslate(
            this.axes.x.func.scale()(d.id) + subScale(d.parentId) + subBarMargin,
            barPos
          )
        })

        // .attr('d', d => {
        sel.select('.main-path').attrTween &&
          sel.select('.main-path').attrTween('d', function (d) {
            let barLength
            if (status === 'enter' || status === 'exit') barLength = 0
            else barLength = getShort(self.axes.y.func.scale()(d.safeValue))
            // let w = longDir === 'width' ? subBarWidth : barLength
            // let h = longDir === 'width' ? barLength : subBarWidth
            // let dent =
            //   longDir === 'width'
            //     ? d.safeValue > 0
            //       ? ['tl', 'br']
            //       : 'bl'
            //     : d.safeValue > 0
            //     ? ['bl', 'tr']
            //     : 'tr'

            let gap = null
            if (
              self.axes.y.func.scale().isChunky &&
              d.safeValue > self.axes.y.func.scale()._threshold
            ) {
              gap =
                self.axes.y.func.scale()(self.axes.y.func.scale()._threshold) -
                self.axes.y.func.scale()(d.safeValue)
            }

            // return dentedRect(w, h, dent, gap)
            return tweenDentedRect.call(this, d, {
              barLength,
              barWidth: subBarWidth,
              longDir,
              scale: self.axes.y.func.scale(),
              gapStart: gap,
            })
          }) &&
          sel.select('.main-path').attrTween('fill', function (d) {
            return fillTween.bind(this)({ ...d, id: d.parentId })
          })
      }
    } else {
      drawItem = (sel, status) => {
        sel.attr('transform', d => {
          let barPos
          if (status === 'enter' || status === 'exit')
            barPos = getOffset(this.axes.y.func.scale()(0))
          else barPos = getOffset(this.axes.y.func.scale()(d.safeValue))
          return getTranslate(this.axes.x.func.scale()(d.id) + barMargin, barPos)
        })
        //sel.select('.main-path').attr('fill', d => this.fill({ id: d.id }))
        sel.select('.main-path').attrTween &&
          sel.select('.main-path').attrTween('d', function (d) {
            let barLength
            if (status === 'enter' || status === 'exit') barLength = 0
            else barLength = getShort(self.axes.y.func.scale()(d.safeValue))
            // let w = longDir === 'width' ? barWidth : barLength
            // let h = longDir === 'width' ? barLength : barWidth
            // let dent =
            //   longDir === 'width'
            //     ? d.safeValue > 0
            //       ? ['tl', 'br']
            //       : 'bl'
            //     : d.safeValue > 0
            //     ? ['bl', 'tr']
            //     : 'tr'

            let gap = null
            if (
              self.axes.y.func.scale().isChunky &&
              d.safeValue > self.axes.y.func.scale()._threshold
            ) {
              gap =
                self.axes.y.func.scale()(self.axes.y.func.scale()._threshold) -
                self.axes.y.func.scale()(d.safeValue)
            }
            return tweenDentedRect.call(this, d, {
              barLength,
              barWidth,
              longDir,
              scale: self.axes.y.func.scale(),
              gapStart: gap,
            })
            // return dentedRect(w, h, dent, gap)
          }) &&
          sel.select('.main-path').attrTween('fill', fillTween)
      }
    }
    //Adding placeholders for progress chart
    const itemsMerged = this.items.merge(this.itemsEnter)
    let placeholderPaths = itemsMerged.selectAll('.placeholder-path').data(
      d => (this.config.mode === 'progress' && this.config.placeholderColor ? [d] : []),
      d => d.id
    )
    const placeholderPathsEnter = placeholderPaths
      .enter()
      .append('path')
      .attr('class', 'placeholder-path')
    placeholderPaths = placeholderPaths.merge(placeholderPathsEnter)
    const placeholderDrawPathFunction = d => {
      let barLength = getShort(self.axes.y.func.scale()(100))
      let gap = null
      return tweenDentedRect.call(this, d, {
        barLength,
        barWidth,
        longDir,
        scale: self.axes.y.func.scale(),
        gapStart: gap,
      })
    }

    const getPlaceholderPathColor = d => {
      switch (this.config.placeholderColor?.toLowerCase()) {
        case 'tint':
          return this.color({ id: d.id })
        case 'sky':
          return isDarkMode(this.config, this._parent.accessibilityOptions) ? '#444444' : '#f6fafc'
        case 'white':
          return isDarkMode(this.config, this._parent.accessibilityOptions)
            ? COLORS.SKIN_BACKGROUND_DARK
            : COLORS.SKIN_BACKGROUND
        default:
          return this.config.placeholderColor
      }
    }

    placeholderPaths
      .attr('fill', d => getPlaceholderPathColor(d))
      .style('opacity', this.config.placeholderColor?.toLowerCase() === 'tint' ? 0.2 : 1)
      //.style('pointer-events', 'none')
      .transition()
      .duration(10)
      .attrTween('d', placeholderDrawPathFunction)

    //placeholderPaths.exit().style('opacity', 0)
    this.itemsExitTrans.select('.placeholder-path').style('opacity', 0)
    this.itemsEnter.append('path').attr('class', 'main-path')

    // HAy que pintar lo "viejos" primero para assegurar que se mantiene el orden de colores...
    this.itemsTrans.call(drawItem) //.style('opacity', 1)
    this.itemsEnter.call(drawItem, 'enter')
    this.itemsEnterTrans.call(drawItem).style('opacity', 1)
    this.itemsExitTrans.style('opacity', 0)
    if (this.parentItemsExitTrans) this.parentItemsExitTrans.style('opacity', 0)

    //DRAW MIN AND MAX
    let minMaxValues
    let minAndMaxDotsOffset = 0
    if (this.config.highlightMaxValue || this.config.highlightMinValue) {
      minAndMaxDotsOffset = 16
      this.itemsEnter.merge(this.items).each(item => {
        const value = this.config.mode === 'stacked' ? item.barMax : item.value
        if (!minMaxValues)
          minMaxValues = {
            min: {
              id: item.id,
              parentId: item.parentId,
              value,
              safeValue: item.safeValue,
            },
            max: { id: item.id, parentId: item.parentId, value, safeValue: item.safeValue },
          }
        else {
          if (minMaxValues.max.value <= value) {
            minMaxValues.max.value = value
            minMaxValues.max.id = item.id
            minMaxValues.max.parentId = item.parentId
            minMaxValues.max.safeValue = item.safeValue
          } else if (minMaxValues.min.value >= value) {
            minMaxValues.min.value = value
            minMaxValues.min.id = item.id
            minMaxValues.min.parentId = item.parentId
            minMaxValues.min.safeValue = item.safeValue
          }
        }
      })
    }

    const getLimitDots = d => {
      let result = []
      if (this.config.mode === 'stacked') {
        if (!d.isLastLayer) return []
      }

      if (this.config.highlightMaxValue) {
        if (
          minMaxValues?.max.id === d.id &&
          (this.config.mode === 'stacked' || minMaxValues.max.parentId === d.parentId)
        ) {
          result = [{ ...minMaxValues.max }]
        }
      }
      if (this.config.highlightMinValue) {
        if (
          minMaxValues?.min.id === d.id &&
          (this.config.mode === 'stacked' || minMaxValues.min.parentId === d.parentId)
        ) {
          result = [{ ...minMaxValues.min }]
        }
      }
      return result
    }

    let limitDotsGhost = itemsMerged.selectAll('.limit-dot-ghost').data(
      d => getLimitDots(d),
      (_, i) => i
    )
    const limitDotsGhostEnter = limitDotsGhost
      .enter()
      .append('circle')
      .attr('class', 'limit-dot-ghost')
      .attr('r', 0)
      .attr('opacity', 0)
      .attr('stroke-width', 2.5)
    //.style('stroke-dasharray', 2)
    limitDotsGhost.exit().transition().duration(800).attr('r', 0).attr('opacity', 0).remove()
    limitDotsGhost = limitDotsGhost.merge(limitDotsGhostEnter)

    let limitDots = itemsMerged.selectAll('.limit-dot').data(
      d => getLimitDots(d),
      (_, i) => i
    )
    const limitDotsEnter = limitDots
      .enter()
      .append('circle')
      .attr('class', 'limit-dot')
      .attr('r', 0)
      .attr('opacity', 0)
    //.style('stroke-dasharray', 2)
    limitDots.exit().transition().duration(800).attr('r', 0).attr('opacity', 0).remove()
    limitDots = limitDots.merge(limitDotsEnter)

    const getLimitDotsXPosition = d => {
      if (this.config.horizontal) {
        return getShort(this.axes.y.func.scale()(d.safeValue)) //+ 12
      } else {
        return this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2
      }
    }

    const getLimitDotsYPosition = d => {
      if (this.config.horizontal) {
        return this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2
      } else {
        //return -10
        return 0
      }
    }

    limitDotsGhost
      .raise()
      .attr('cx', d => getLimitDotsXPosition(d))
      .attr('cy', d => getLimitDotsYPosition(d))
      .attr('fill', 'transparent')
      .attr(
        'stroke',
        !isDarkMode(this.config, this._parent.accessibilityOptions)
          ? COLORS.SKIN_BACKGROUND
          : COLORS.SKIN_BACKGROUND_DARK
      )
      //.attr('stroke', d => this.color({ id: d.parentId ? d.parentId : d.id }))
      .transition()
      .duration(800)
      .attr('r', this.config.mode === 'grouped' ? (subBarWidth / 2) * 0.95 : (barWidth / 2) * 0.95)
      .attr('opacity', 1)

    limitDots
      .raise()
      .attr('cx', d => getLimitDotsXPosition(d))
      .attr('cy', d => getLimitDotsYPosition(d))
      .attr('fill', 'transparent')
      .attr(
        'stroke',
        isDarkMode(this.config, this._parent.accessibilityOptions) ? '#FFFFFF' : '#000000'
      )
      //.attr('stroke', d => this.color({ id: d.parentId ? d.parentId : d.id }))
      .transition()
      .duration(800)
      .attr('r', this.config.mode === 'grouped' ? (subBarWidth / 2) * 0.95 : (barWidth / 2) * 0.95)
      .attr('opacity', 1)

    const getDatumValuesXPosition = d => {
      if (this.config.horizontal) {
        switch (this.config.datumValuesPosition) {
          case 'top':
            return (
              getShort(this.axes.y.func.scale()(d.safeValue)) +
              8 +
              (getLimitDots(d)?.length > 0 ? minAndMaxDotsOffset : 0)
            )
          case 'center':
            return getShort(this.axes.y.func.scale()(d.safeValue)) / 2
          case 'bottom':
            return -8
          case 'insideBeginning':
            return 8
          case 'insideEnd':
            return getShort(this.axes.y.func.scale()(d.safeValue)) - 8
        }
      } else {
        return this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2
      }
    }
    const getDatumValuesYPosition = d => {
      if (this.config.horizontal) {
        return this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2
      } else {
        switch (this.config.datumValuesPosition) {
          case 'top':
            return -8 - (getLimitDots(d)?.length > 0 ? minAndMaxDotsOffset : 0)
          case 'insideEnd':
            return 12
          case 'center':
            return getShort(this.axes.y.func.scale()(d.safeValue)) / 2
          case 'bottom':
            return getShort(this.axes.y.func.scale()(d.safeValue)) + 16
          case 'insideBeginning':
            return getShort(this.axes.y.func.scale()(d.safeValue)) - 12
        }
      }
    }

    let datumValues = this.itemsEnter
      .merge(this.items)
      .selectAll('.datum-value')
      .data(d => {
        if (this.config.showDatumValues) {
          if (this.config.mode === 'stacked') {
            switch (this.config.datumValuesPosition) {
              case 'center':
              case 'insideBeginning':
              case 'insideEnd':
                return [{ value: d.y1, safeValue: d.y1 - d.y0 }]
              case 'bottom':
                if (d.isFirstLayer) return [{ ...d, value: d.barMax + d.barMin }]
                return []
              case 'top':
                if (d.isLastLayer) return [{ ...d, value: d.barMax + d.barMin }]
                return []
              default:
                return []
            }
          } else {
            return [d]
          }
        } else {
          return []
        }
      })
    datumValues.exit().transition().style('opacity', 0).remove()
    datumValues = datumValues.merge(
      datumValues
        .enter()
        .append('text')
        .attr('class', 'datum-value')
        .style('opacity', 0)
        .style('font-size', '14px')
        .style('font-weight', 'bold')
        .attr('fill', 'currentColor')
        .attr('x', d => getDatumValuesXPosition(d))
        .attr('y', d => getDatumValuesYPosition(d))
        .text(d => this.formatValue(d.value, 'y'))
    )
    // datumValues
    //   .text(d => {
    //     return this.formatValue(d.value, 'y')
    //   })
    // .text(d => this.valueWithUnit(d.value, 'y'))
    // .transition()
    // .style('opacity', 1)

    datumValues
      .attr('transform', 'rotate(0)')
      .attr('text-anchor', this.config.horizontal ? 'start' : 'middle')
      .style('dominant-baseline', 'middle')
      .style('stroke', 'unset')
      .style('fill', 'currentColor')
      .style(
        'font-size',
        this._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
          ? '18px'
          : '14px'
      )

    datumValues
      .text(d => {
        return this.formatValue(d.value, 'y')
      })
      // .text(d => this.valueWithUnit(d.value, 'y'))
      .transition()
      .duration(1000)
      .attr('x', d => getDatumValuesXPosition(d))
      .attr('y', d => getDatumValuesYPosition(d))
      .style('opacity', 1)
      .textTween(function (d) {
        let i = d3_interpolate(this._currentValue || 0, d.value)
        return t => {
          return self.formatValue((this._currentValue = i(t)), 'y')
        }
      })

    if (this.config.datumValuesPosition === 'bottom') {
      if (this.config.horizontal) {
        datumValues.attr('text-anchor', 'end')
      }
    }

    if (['center', 'insideBeginning', 'insideEnd'].includes(this.config.datumValuesPosition)) {
      /*
      if (!this.config.horizontal) {
        datumValues.attr(
          'transform',
          d => `rotate(-90, ${getDatumValuesXPosition(d)}, ${getDatumValuesYPosition(d)})`
        )
      }
      */
      datumValues.style('dominant-baseline', 'central')
      datumValues.style('paint-order', 'stroke')
      datumValues.style('stroke', 'white')
      datumValues.style('stroke-width', '2px')
      datumValues.style('stroke-linecap', 'butt')
      datumValues.style('stroke-linejoin', 'round')
      datumValues.style('fill', 'black')
    }

    if (this.config.datumValuesPosition === 'center') {
      datumValues.attr('text-anchor', 'middle')
    }

    if (this.config.datumValuesPosition === 'insideBeginning') {
      if (this.config.horizontal) {
        datumValues.attr('text-anchor', 'start')
      }
    }

    if (this.config.datumValuesPosition === 'insideEnd') {
      if (this.config.horizontal) {
        datumValues.attr('text-anchor', 'end')
      }
    }

    // this.itemsEnter.append('text').attr('text-anchor', 'middle')
    // this.items
    //   .merge(this.itemsEnter)
    //   .select('text')
    //   // .text(d => this.formatValue(d.value, 'y'))
    //   .text(d => this.valueWithUnit(d.value, 'y'))
    //   .attr('x', this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2)
    //   .attr('y', -8)
  }

  calcDatumValueOffsets() {
    //ALERTA, {x,y} corresponeden al typo de axis NO a la direccion del offset
    if (this.config.showDatumValues && this.config.datumValuesPosition === 'bottom') {
      let offset = 20
      if (this.config.horizontal) {
        this.root.selectAll('.datum-value').each(function (d) {
          offset = Math.max(offset, this.getBoundingClientRect().width + 10)
        })
      }
      return { x: offset, y: 0 }
    }
    return { x: 0, y: 0 }
  }
}
